import es from "../messagesJson/es.json";
export const PartialMessages = {
    es,
} as const;
